export const cardTheme = {
  colorScheme: {
    light: {
      root: {
        background: 'var(--surface-fill)',
        borderRadius: '8px',
        color: '{content.color}',
        // Inset box-shadow renders the 1px border (PrimeNG Card has no border token in v21).
        shadow: 'inset 0 0 0 1px var(--surface-stroke), var(--tile-shadow)'
      },
      body: {
        padding: '2px',
        gap: '0.5rem'
      },
      caption: {
        gap: '0.5rem'
      },
      title: {
        fontSize: '1.25rem',
        fontWeight: '500'
      },
      subtitle: {
        color: '{text.muted.color}'
      }
    },
    dark: {
      root: {
        background: 'var(--surface-fill)',
        borderRadius: '8px',
        color: '{content.color}',
        // Dark mode keeps the inset border but drops the outer shadow (--tile-shadow is `none` in dark).
        shadow: 'inset 0 0 0 1px var(--surface-stroke)'
      },
      body: {
        padding: '2px',
        gap: '0.5rem'
      },
      caption: {
        gap: '0.5rem'
      },
      title: {
        fontSize: '1.25rem',
        fontWeight: '500'
      },
      subtitle: {
        color: '{text.muted.color}'
      }
    }
  }
};
